import { FeeKind, Ticker } from '@ppay/definitions'

import { FeeValue } from '../../../../../interfaces/merchant/Fees'

export const getFeeValueString = (ticker: Ticker, val: FeeValue) => {
  if (val.kind === FeeKind.Percent) return `${val.value} %`
  return `${Number(val.value).toFixed(6)} ${ticker}`
}
